<template>
  <loading v-if="loading" />

  <div id="wrapper" :class="noheader">
    <div class="header">
      <div class="content shadow">
        <div class="inner">
          <div class="logo">
            <a>
              <img class="mobile" src="@/assets/images/logo_s.svg" width="20" />
              <img class="pc" src="@/assets/images/logo.svg" width="164" />
            </a>
          </div>
          <div class="text"><p>木生婦幼診所</p></div>
          <div class="hamburgerBox">
            <a class="hamburger hamburger--spin">
              <span class="hamburger-box">
                <span class="hamburger-inner"></span>
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="bg"></div>
    <template v-if="member.info.verified">
      <div class="userBox">
        <div class="userPicBox">
          <div class="userPic active" :style="userPicture"></div>
        </div>
        <div class="text">
          <div class="name">{{ currentPatient.name }} 您好!</div>
          <div class="email">病歷號：{{ currentPatient.patientNo }}</div>
          <template v-if="patients.length > 1">
            <a
              class="change"
              @click.prevent="changeCurrent"
              style="font-size:1rem; bottom: 0px;"
              >切換身份<img src="@/assets/images/icon_change.svg"
            /></a>
          </template>
        </div>
      </div>

      <LightBox />

      <div class="btnsBox">
        <a class="btn" @click="$router.replace('/CheckIn')">
          <div class="inner">
            <img src="@/assets/images/icon_qr.svg" />
            <p>就診報到</p>
          </div>
        </a>
        <a class="btn" @click="$router.replace('/WaitInfo')">
          <div class="inner">
            <img src="@/assets/images/icon_scope.svg" />
            <p>看診進度</p>
          </div>
        </a>
        <a class="btn" @click="$router.replace('/Appointment')">
          <div class="inner">
            <img src="@/assets/images/icon_calendar.svg" />
            <p>預約掛號</p>
          </div>
        </a>
      </div>
      <div class="listBox">
        <a
          class="box"
          v-if="member.info.first"
          @click="openWindow('https://liff.line.me/1655966565-nLRbw5D0', false)"
        >
          <div class="icon">
            <img src="@/assets/images/icon_book.svg" width="28" />
          </div>
          <div class="text">
            <p>
              您有&nbsp;<span>1</span>&nbsp;&nbsp;份初診表單需填寫（請於當日問診前完成）
            </p>
          </div>
        </a>
      </div>
    </template>
    <template v-else>
      <div class="userBox">
        <div class="userPicBox">
          <div class="userPic"></div>
          <!-- <a class="upload"><img src="@/assets/images/upload.png"/></a> -->
        </div>
        <div class="text">
          <div class="name">親愛的訪客您好</div>
          <div class="email">
            您尚未綁定LINE帳號
            <a
              class="change"
              @click.prevent="$router.replace('/SignUp')"
              style="font-size:1rem; bottom: 0px;"
              >按此綁定
            </a>
          </div>
        </div>
      </div>

      <LightBox />

      <div class="btnsBox">
        <div class="btn" @click="checkIn">
          <div class="inner">
            <img src="@/assets/images/icon_qr.svg" alt="就診報到QRCode" />
            <p>就診報到</p>
          </div>
        </div>
        <div class="btn">
          <a
            class="btn"
            @click="
              member.platform.match(/^(line|develop)$/)
                ? openWindow('https://liff.line.me/1655966565-RgOZy8jw', false)
                : $router.replace('/WaitInfo')
            "
          >
            <div class="inner">
              <img src="@/assets/images/icon_scope.svg" alt="看診進度" />
              <p>看診進度</p>
            </div>
          </a>
        </div>
        <div class="btn">
          <a
            class="btn"
            @click="
              member.platform.match(/^(line|develop)$/)
                ? openWindow('https://liff.line.me/1655966565-M17Ln2QG', false)
                : $router.replace('/Appointment')
            "
          >
            <div class="inner">
              <img src="@/assets/images/icon_calendar.svg" />
              <p>預約掛號</p>
            </div>
          </a>
        </div>
      </div>
    </template>
  </div>

  <modal v-if="modal.display" @close="modal.display = false">
    <template v-slot:header>{{ modal.header }}</template>
    <template v-slot:body>{{ modal.body }}</template>
  </modal>

  <debug v-if="debug">{{ member }}</debug>
  <debug v-if="debug">{{ patients }}</debug>
</template>

<script>
import LightBox from "../components/LightBox.vue";
import liff from "@line/liff";
import api from "../api/index";

export default {
  components: {
    LightBox
  },
  data() {
    return {
      debug: eval(process.env.VUE_APP_DEBUG),
      loading: true,
      modal: {}
    };
  }, //data
  computed: {
    noheader() {
      return this.member.platform.match(/^(line|develop)$/) ? "noheader" : null;
    },
    member() {
      return this.$store.state.member;
    },
    userPicture() {
      return this.member.info.linePictureUrl
        ? { backgroundImage: "url(" + this.member.info.linePictureUrl + ")" }
        : null;
    },
    patients() {
      if (this.member.info.child) {
        const patients = this.member.info.child.map(c => c.patientNo); //['寶病歷號','寶病歷號']
        patients.unshift(this.member.info.patientNo); //['媽病歷號','寶病歷號','寶病歷號']
        return patients;
      } else {
        return [this.member.info.patientNo]; //['媽病歷號']
      }
    },
    currentPatient() {
      if (this.member.info.verified && this.member.info.child) {
        if (this.member.info.current === this.member.info.patientNo) {
          return this.member.info; //媽
        } else {
          const child = this.member.info.child.find(
            c => c.patientNo === this.member.info.current
          );
          if (child === undefined) {
            //current找不到任何相符的病歷號, 病歷號可能有異動過
            return this.member.info; //媽
          }
          return child; //寶
        }
      } else {
        return this.member.info;
      }
    }
  },
  mounted() {
    this.loading = false;
  },
  methods: {
    changeCurrent() {
      const current = this.member.info.current;
      const idx = this.patients.indexOf(current);
      const next = idx + 1 < this.patients.length ? idx + 1 : 0;
      const patient = this.patients[next];
      console.log(
        `Current ${current} at: ${idx}, next is ${patient} at: ${next}`
      );
      this.loading = true;
      api.member
        .change({
          jwt: this.member.jwt,
          current: patient
        })
        .then(data => {
          this.loading = false;
          console.log(data);
          this.$store.dispatch("login", {
            jwt: this.member.jwt,
            platform: this.member.platform,
            info: data.member,
            params: this.member.params
          });
        })
        .catch(error => {
          this.loading = false;
          this.modal = {
            display: true,
            header: "網路連線異常",
            body: error.message
          };
        });
    },
    checkIn() {
      this.modal = {
        display: true,
        header: "提醒",
        body: "請先綁定會員才能報到喔！"
      };
    },
    openWindow(url, external) {
      liff.openWindow({
        url: url,
        external: external
      });
    }
  }
};
</script>
